let initTokenExpiration = () => {
	let time = null;
	if (localStorage.getItem("blobTokenExpiration")) {
		try {
			time = new Date(JSON.parse(localStorage.getItem("blobTokenExpiration")));
		} catch {}
	}
	return time;
};

export default {
	token: '',
	tokenExpiration: initTokenExpiration(),
};
